module.exports = __webpack_public_path__ + "media/Video 46c.1e52eb84.mp4";